import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { Permission } from 'app/permissions/store/permission.model';
import { Store } from '@ngrx/store';
import * as fromApp from '../../store/app.reducer';
import { PermissionType } from '../../enums/enums';
import { LoggedInUserInformation } from 'app/storeInformation/loogedInUserInformation/store/loggedinuser-information.model';
import { ScreenInformation } from 'app/screeninformation/store/screeninformation.model';
import { BaseService } from '../services/base.service';
import * as PermissionActions from '../../permissions/store/permission.actions';
import { localStorageInformationId, systemConstants } from '../modals/common';
import { DashboardInformationService } from '../services/dashboard-information.service';
import { map, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoaderService } from '../services/loader.service'; import { AngularFireAuth } from '@angular/fire/auth';
@Injectable()
export class AuthService {
  private user: Observable<firebase.User>;
  private userDetails: firebase.User = null;
  allPagePermissions: Permission[] = [];
  subscription: Subscription;
  userInformation: LoggedInUserInformation;
  screenInformation: ScreenInformation[] = [];

  constructor(public _firebaseAuth: AngularFireAuth, public router: Router,
    private store: Store<fromApp.AppState>,
    private dashboardInformationService: DashboardInformationService,
    private baseService: BaseService, private http: HttpClient,
    private loaderService: LoaderService) {
    // this.user = _firebaseAuth.authState;
    // this.user.subscribe(
    //   (user) => {
    //     if (user) {
    //       this.userDetails = user;
    //     }
    //     else {
    //       this.userDetails = null;
    //     }
    //   }
    // );

    if (this.allPagePermissions.length == 0) {
      this.subscription = this.store
        .select('permission')
        .subscribe(data => {
          console.log("permissions logged");
          console.log(data.permissions);
          this.allPagePermissions = data.permissions;
        });
      this.subscription = this.store
        .select('loggedInUserInformation')
        .subscribe(data => {
          this.userInformation = data.loggedInUserInformation;
        });

      this.subscription = this.store
        .select('screenInformation')
        .subscribe(data => {
          this.screenInformation = data.screenInformation.filter(e => e['length'] == 1).length > 1 ? JSON.parse(data.screenInformation.join('')) : data.screenInformation;
        });
    }
  }

  signupUser(email: string, password: string) {
    //your code for signing up the new user
  }

  signinUser(email: string, password: string) {
    //your code for checking credentials and getting tokens for for signing in user
    // return this._firebaseAuth.signInWithEmailAndPassword(email, password)

    //uncomment above firebase auth code and remove this temp code
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        resolve(true);
      }, 1000);
    });

  }

  logout() {
    //this._firebaseAuth.signOut();
    this.router.navigate(['YOUR_LOGOUT_URL']);
  }

  isAuthenticated() {
    return true;
  }

  isTaskPermissionAllowed(taskId, permissionEnum: PermissionType): Observable<boolean> {
    if (this.allPagePermissions.length == 0) {

      const userdata = this.baseService.getLocalData(localStorageInformationId.userTokenInfo);
      let headers = new HttpHeaders({
        'AuthenticationKey': 'NetVidyalaya@123',
        'OrgId': userdata.orgId.toString(),
        'Authorization': `bearer ${this.baseService.getToken()}`,
        'content-type': 'application/json'
      });

      this.loaderService.showLoader();
      return this.http.post(systemConstants.domain + '/dashboardInformation/getDashboardInformation', null, { headers }).pipe(
        tap(res => (localStorage.data = JSON.stringify(res))),
        map(res => {
          this.loaderService.hideLoader();
          console.log('isTaskPermissionAllowed responded');
          console.log(res);
          if (res['statusCode'] == 1) {
            let dashboardInformation = JSON.parse(res['data']);

            if (dashboardInformation.IsUserLoggedIn) {
              this.allPagePermissions = dashboardInformation.PermissionListData ?
                dashboardInformation.PermissionListData : [];
              this.store.dispatch(new PermissionActions.AddPermission(this.allPagePermissions));
              const permissionData = this.allPagePermissions.find(permission => permission.TaskID == taskId);
              if (!permissionData) {
                return false;
              }

              let permissionVal: boolean;
              switch (permissionEnum) {
                case PermissionType.Create:
                  permissionVal = permissionData.Create;
                  break;
                case PermissionType.Delete:
                  permissionVal = permissionData.Delete;
                  break;
                case PermissionType.Execute:
                  permissionVal = permissionData.Execute;
                  break;
                case PermissionType.Print:
                  permissionVal = permissionData.Print;
                  break;
                case PermissionType.Read:
                  permissionVal = permissionData.Read;
                  break;
                case PermissionType.Update:
                  permissionVal = permissionData.Update;
                  break;
                default:
                  permissionVal = false;
              }
              return permissionVal;
            } else {
              var loginPageUrl = 'Pages/Baseframework/Security/Login';
              window.location.href = loginPageUrl;
              return false;
            }
          } else {
            var loginPageUrl = 'Pages/Baseframework/Security/Login';
            window.location.href = loginPageUrl;
            return false;
          }

        }, error => {
          this.loaderService.hideLoader();
          return false;
        })
      );

    } else {
      const permissionData = this.allPagePermissions.find(permission => permission.TaskID == taskId);
      if (!permissionData) {
        return of(false);
      }

      switch (permissionEnum) {
        case PermissionType.Create:
          return of(permissionData.Create);

        case PermissionType.Delete:
          return of(permissionData.Delete);

        case PermissionType.Execute:
          return of(permissionData.Execute);

        case PermissionType.Print:
          return of(permissionData.Print);

        case PermissionType.Read:
          return of(permissionData.Read);

        case PermissionType.Update:
          return of(permissionData.Update);

        default:
          return of(false);
      }
    }
  }
  getUserDetail() {
    return this.userInformation;
  }

  getScreenList() {
    return this.screenInformation;
  }
}
